import { render, staticRenderFns } from "./RequirementsModal.vue?vue&type=template&id=64f064bb"
import script from "./RequirementsModal.vue?vue&type=script&lang=js"
export * from "./RequirementsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports